import type { FC } from 'react';
import type { IClinicalRunbook } from '../use-clinical-runbook';

interface Props {
  runbook: IClinicalRunbook;
}

/** Inline display of the clinic's critical-escalation runbook instruction. */
export const RunbookInstruction: FC<Props> = ({ runbook }) => {
  if (runbook.loading) {
    return <p>Loading clinic runbook…</p>;
  }

  if (!runbook.hasCriticalEntry) {
    return (
      <div>
        <p style={{ fontWeight: 600 }}>Clinic Runbook</p>
        <p>
          No critical-escalation entry for this clinic — system default applies:
          Escalate to Clinic.
        </p>
      </div>
    );
  }

  return (
    <div>
      <p>
        <strong>Clinic Runbook — Critical Escalation</strong>
      </p>
      <p>{runbook.criticalInstruction}</p>
      {runbook.contactMethod && (
        <p>
          <strong>Contact method:</strong> {runbook.contactMethod}
        </p>
      )}
      {runbook.notes && (
        <p>
          <strong>Notes:</strong> {runbook.notes}
        </p>
      )}
    </div>
  );
};
